import { Button, Divider, Flex, Modal, Typography } from 'antd'
import React from 'react'
import { ButtonCTA } from '~/features/shared/components'
import { IconText } from '~/features/shared/icons'
import { ImageOptimizedClient } from '~/plugins/image-optimize/client'
import { MixpanelClient } from '~/plugins/mixpanel/client'
import { usePwaContext } from '../../context'

const Internal: React.FC = () => {
  const { installation } = usePwaContext()

  const mixpanel = MixpanelClient.use()

  const handleClose = () => {
    installation.setVisible(false)
  }

  const handleRefuse = () => {
    mixpanel.track('pwa.installation.refused')
    handleClose()
  }

  const handleAccept = () => {
    mixpanel.track('pwa.installation.accepted')
    installation.install()
  }

  if (!installation.isVisible) {
    return <></>
  }

  return (
    <>
      <Modal
        open={true}
        footer={false}
        onCancel={installation.canInstallPrompt ? handleRefuse : handleClose}
      >
        <Flex vertical>
          <Flex align="center" gap={16}>
            <ImageOptimizedClient.Img
              width="52px"
              isPretty={true}
              src="/pwa/icon.png"
            />

            <Flex flex={1}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                Install Marblism
              </Typography.Title>
            </Flex>
          </Flex>

          <Divider />

          <Typography.Text className="mb-4">
            Install our app on your device for a better experience with
            notifications
          </Typography.Text>

          {installation.canInstallPrompt ? (
            <>
              <Flex className="mt-5" vertical gap={8}>
                <ButtonCTA onClick={handleAccept}>Install</ButtonCTA>
                <Button type="text" onClick={handleRefuse}>
                  Not right now
                </Button>
              </Flex>
            </>
          ) : (
            <>
              <Typography.Text>
                1. Tap on <IconText name="arrow-up-on-square-outlined" />
              </Typography.Text>

              <Typography.Text>
                2. Select{' '}
                <Typography.Text code> Add to Home Screen</Typography.Text>
              </Typography.Text>

              <Flex className="mt-10" justify="right" onClick={handleClose}>
                <Button>Close</Button>
              </Flex>
            </>
          )}
        </Flex>
      </Modal>
    </>
  )
}

export const InstallationModal: React.FC = () => {
  const { isSupported } = usePwaContext()

  if (!isSupported) {
    return <></>
  }

  return <Internal />
}
